const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const normalizeApiBaseUrl = () => {
  const configuredUrl = trimTrailingSlash(process.env.REACT_APP_API_URL || '/api');

  return configuredUrl.endsWith('/api') ? configuredUrl : `${configuredUrl}/api`;
};

export const API_BASE_URL = normalizeApiBaseUrl();

export const AUTH_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_AUTH_BASE_URL ||
    process.env.REACT_APP_API_URL1 ||
    API_BASE_URL.replace(/\/api$/, ''),
);

export const buildApiUrl = (path: string) =>
  `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;

export const buildAuthUrl = (path: string) =>
  `${AUTH_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;

export const normalizeApiRequestUrl = (url?: string) => {
  if (!url) {
    return url;
  }

  if (url.startsWith('/api') || url.startsWith('blob:') || url.startsWith('data:')) {
    return url;
  }

  if (url.startsWith('/')) {
    return buildApiUrl(url);
  }

  try {
    const apiBaseUrl = new URL(API_BASE_URL, window.location.origin);
    const requestUrl = new URL(url);

    if (
      requestUrl.origin === apiBaseUrl.origin &&
      !requestUrl.pathname.startsWith('/api/')
    ) {
      requestUrl.pathname = `/api${requestUrl.pathname}`;
      return requestUrl.toString();
    }
  } catch {
    return url;
  }

  return url;
};
